import React from "react";
import { useSelector } from "react-redux";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Doughnut } from "react-chartjs-2";
import styles from "./dashBoardStyles.module.css";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  ArcElement,
  Title,
  Tooltip,
  Legend
);

const StorageSection = () => {
  const data = useSelector((state) => state.dashboard.data);
  const storageInfoData = {
    data: {
      labels: Object.keys(data.storage),
      datasets: [
        {
          label: "storage",
          data: Object.values(data.storage),
          backgroundColor: [
            "rgb(255, 99, 132)",
            "rgb(54, 162, 235)",
            "rgb(255, 205, 86)",
          ],
          hoverOffset: 4,
        },
      ],
    },
  };
  return (
    <section className={styles.storageInfo}>
      <h1>Storage Information</h1>
      <div style={{width:'80%',height:'80%',margin:"0px 20px"}}>
      <Doughnut options={{ responsive: true, maintainAspectRatio:false,color:"white" }} data={storageInfoData.data} />
      </div>
    </section>
  );
};

export default StorageSection;
